/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserLastNameQueryVariables = GraphQL.Exact<{
  legacyUserId: GraphQL.Scalars['ID']['input'];
}>;


export type UserLastNameQuery = { readonly __typename?: 'Query', readonly user: { readonly __typename?: 'User', readonly id: string, readonly lastName: string | null, readonly legacyId: string } | null };


export const UserLastNameDocument = gql`
    query UserLastName($legacyUserId: ID!) {
  user(legacyId: $legacyUserId) {
    id
    lastName
    legacyId
  }
}
    `;

/**
 * __useUserLastNameQuery__
 *
 * To run a query within a React component, call `useUserLastNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserLastNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserLastNameQuery({
 *   variables: {
 *      legacyUserId: // value for 'legacyUserId'
 *   },
 * });
 */
export function useUserLastNameQuery(baseOptions: Apollo.QueryHookOptions<UserLastNameQuery, UserLastNameQueryVariables> & ({ variables: UserLastNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserLastNameQuery, UserLastNameQueryVariables>(UserLastNameDocument, options);
      }
export function useUserLastNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserLastNameQuery, UserLastNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserLastNameQuery, UserLastNameQueryVariables>(UserLastNameDocument, options);
        }
export function useUserLastNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserLastNameQuery, UserLastNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserLastNameQuery, UserLastNameQueryVariables>(UserLastNameDocument, options);
        }
export type UserLastNameQueryHookResult = ReturnType<typeof useUserLastNameQuery>;
export type UserLastNameLazyQueryHookResult = ReturnType<typeof useUserLastNameLazyQuery>;
export type UserLastNameSuspenseQueryHookResult = ReturnType<typeof useUserLastNameSuspenseQuery>;
export type UserLastNameQueryResult = Apollo.QueryResult<UserLastNameQuery, UserLastNameQueryVariables>;